
/***进入主页*/
import pageTpl from '../template/page.tmpl';
import pageContentTpl from '../template/page-content.tmpl';
import createTab from '../component/createTabAndList/index';
import TaskComponent from '../component/task/index';

import GalaPop from '../lib/normalPop.js';

class Home {

	constructor(userToken,uid,acid){
		this.userToken = userToken;
		this.uid = uid;
        this.acid = acid;
        this.actInfo = UpAct.actData[acid];
        this.showTask = false;
        this.selectedAreaIndex = 0;
        this.getAreaIndex();
	}
	renderHomePage(){

		let self = this;
        this.renderHTML();
        this.showTask && this.renderTaskHTML();
        this.bindEvent();
    }

    setActTime(actInfo){
        let cfg = actInfo.overallRanking;
        let time = UpAct.TimeUtil.getDailyTimeWithDate(cfg.startTime*1000,cfg.endTime*1000,UpAct.lang.lang);
        $(".header .act-time").html(UpAct.lang.template('活动时间:{time}',{time: time}));
    }

    getAreaIndex(){
        let self = this;
        let langType = UpAct.lang.langType;

        $.each(UpAct.CONFIG.acidConfig.acid, (index, items)=>{
            if (items.uniqueId.indexOf(langType) > -1) {
                this.selectedAreaIndex = index;
            }
        });
    }

    renderHTML() {
        let self = this;
        let html = pageTpl({
            actInfo: self.actInfo,
            showTask: self.showTask
        });

        $('#wrap').html(html);

        let panel = $("#page-content");

        let tabsList = new createTab(this.acid,panel);

        tabsList.renderTabs(UpAct.CONFIG.acidConfig,panel)

        // if(self.actInfo.status == 1){
        //     $("#J-Countdown").removeClass('hidden');
        // }

        return;

        let pageContentHtml = pageContentTpl({
            actInfo: self.actInfo,
            tabs: UpAct.CONFIG.acid,
        });
        $("#page-content").html(pageContentHtml);
        console.log(this.selectedAreaIndex);

        let tabView = new UpAct.TabView({
            wrap:'#J-List',
            selectedIndex: this.selectedAreaIndex,
            direction: UpAct.lang.langType == 'areg' ? 'right':'left',
            scrollable: true
        });
        tabView.on('select',(e)=>{

            let panel = e.panel;

            this.selectedAreaIndex = e.index;

            let tabsList = new createTab(this.acid,panel);

            tabsList.renderTabs(UpAct.CONFIG.acidConfig.acid[this.selectedAreaIndex],panel,1)
        });

        tabView.render();
        
    }
    renderTaskHTML(){
        let taskComponent = new TaskComponent({
            wrap: $('.task-info'),
            userToken: this.userToken,
            acid: UpAct.CONFIG.getTaskActId(),
        });
        taskComponent.render();
        
    }

    getBtnContext = ()=>{
        return `
            <div class="gala-pop-btn" node-id="guardBtn">
                ${UpAct.lang.template('知道了')}
            </div>`;
    }

    bindEvent(){
        let self = this;

        $('#wrap').delegate('[node-id="goshouhu"]','click',function(e){
            e.stopPropagation();
            let target = e.currentTarget;
            let uid = $(target).data('uid');
            let acid = $(target).data('acid');
            $.channel.emit('goShouHu',{uid:uid,acid:acid});

        });
        let wrap = $(document.body);

        wrap.delegate('[node-id="rule-btn"]','click',()=>{
            let pop = new GalaPop({
                title: UpAct.lang.template('活动规则'),
                context: UpAct.lang.template('活动规则的内容')+
                    (UpAct.lang.langType === 'zhtw'?`<div class="rule-gift2"><img src="${require('../../images/rule-gift2.jpg')}"></div>`:''),
                //btnContext: ,
                onCreate: (el,popup,gala)=>{
                    el.addClass('widget-poplayer-rule');
                },
                onClose: (el)=>{
                }
            });

            pop.create();
        });

        wrap.delegate('.tab[data-tabindex="0"]','click',function(e){
            let index = $('.tab[data-tabindex="0"]').index(this);
            let acid = UpAct.CONFIG.acidConfig.acid[index].acid[0].acid[0].acid;
            let actInfo = UpAct.actData[acid];
            self.setActTime(actInfo)
            console.log(index,$(this))
        });

        let toggle = 1;

        $('#wrap').delegate('.intro-toggle','click',function(e){
            $('.intro')[ !toggle?'addClass':'removeClass']('intro-hidden');
            toggle ^= 1;
        });
    }
}
module.exports = Home;


// WEBPACK FOOTER //
// ./js/view/home.js